/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Cal_6_DInputs */

const en_cp_cal_6_d = /** @type {(inputs: Cp_Cal_6_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fix exceptions, deploy, auto wiki, proposal PDF / report appendix.`)
};

const id_cp_cal_6_d = /** @type {(inputs: Cp_Cal_6_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perbaiki pengecualian, deploy, wiki otomatis, proposal PDF / lampiran laporan.`)
};

/**
* | output |
* | --- |
* | "Fix exceptions, deploy, auto wiki, proposal PDF / report appendix." |
*
* @param {Cp_Cal_6_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_cal_6_d = /** @type {((inputs?: Cp_Cal_6_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Cal_6_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_cal_6_d(inputs)
	return en_cp_cal_6_d(inputs)
});